import { defineMessages } from 'react-intl';
export const dictationMessages = defineMessages({
    listening: {
        defaultMessage: 'Listening…',
        description: 'Placeholder text shown in the ask input when voice transcription is active',
        id: '2a4589ffa8',
    },
    start: {
        defaultMessage: 'Dictation',
        description: 'Aria label for the dictation button to start voice transcription',
        id: '177dd2edd7',
    },
    stop: {
        defaultMessage: 'Stop dictation',
        description: 'Aria label for the button to stop voice dictation',
        id: '16886108db',
    },
    submit: {
        defaultMessage: 'Submit dictation',
        description: 'Aria label for the button to submit the dictated text',
        id: '9803f806ca',
    },
});
//# sourceMappingURL=messages.js.map